import ApiERP from '@/core/conectores/ApiERP';
import { IListaPaginada } from '@/core/models/Consulta/IListaPaginada';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IFiltroRelatorioAnaliseEstoque } from '@/models/Relatorios/Estoque/IFiltroRelatorioAnaliseEstoque';
import { IDadosRelatorioAnaliseEstoque } from '@/models/Relatorios/Estoque/IDadosRelatorioAnaliseEstoque';

/**
 * Serviço de Relatórios de Vendas.
 */

class ServicoRelatorioEstoque {
    endPoint = 'relatorios-estoques';

    apiERP = new ApiERP();

    public requisicaoSistema():void{
      this.apiERP = new ApiERP(true);
    }

    public async obterArquivoAnaliseEstoque(tipoArquivo: ETipoArquivo, filtros: IFiltroRelatorioAnaliseEstoque):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/analise-estoque/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterAnaliseEstoque(filtros: IFiltroRelatorioAnaliseEstoque): Promise<IDadosRelatorioAnaliseEstoque> {
      const result: any = await this.apiERP.post(`${this.endPoint}/analise-estoque`, filtros);
      const listaPaginada = {} as IListaPaginada;
      listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
      listaPaginada.dados = result.data.itens;
      result.data.itens = listaPaginada;
      return result.data;
    }
}
export default ServicoRelatorioEstoque;
